<template>
    <modal
        name="course-rating"
        @before-open="beforeOpen"
        @before-close="beforeClose"
        width="80%"
        height="auto"
        :max-width="600"
        :adaptive="true"
        :scrollable="true"
        classes="course-rating-modal"
    >
        <div class="modal-course-rating">
            <h2 v-html="$t('Rating.rate_this_course_headline')"></h2>
            <h3 class="modal-course-rating__course-title">{{ courseTitle }}</h3>
            <div class="modal-course-rating__rating-item">
                <span class="modal-course-rating__question" v-html="$t('Rating.question_course_content_quality')"></span>
                <TotemStarRating class="modal-course-rating__stars" @setRating="setContentRating" v-model="rating.contentQuality" />
            </div>
            <div class="modal-course-rating__rating-item">
                <span class="modal-course-rating__question" v-html="$t('Rating.question_trainer_perform')"></span>
                <TotemStarRating class="modal-course-rating__stars" @setRating="setTrainerRating" v-model="rating.trainerPerform" />
            </div>
            <div class="modal-course-rating__rating-item">
                <span class="modal-course-rating__question" v-html="$t('Rating.question_how_much_learn')"></span>
                <TotemStarRating class="modal-course-rating__stars" @setRating="setLearningRating"  v-model="rating.learningRate" />
            </div>
            <TotemTextarea v-model="rating.ratingDescription" rows="5" class="modal-course-rating__textarea" :placeholder="$t('Rating.user_rating_explanation_hint')" v-if="isAllRatingDone"/>
            <span class="modal-course-rating__feedback-info" v-html="$t('Rating.collecting_feedback_info')"></span>
            <div class="modal-course-rating__buttons">
                <TotemButton
                    color="basic"
                    @click="$modal.hide('course-rating')"
                    class="modal-course-rating__close-button"
                    :label="$t('General.close')"
                />
                <TotemButton
                    color="primary"
                    @click="sendRating"
                    class="-margin-left"
                    :disabled="!isAllRatingDone"
                    :label="$t('Rating.save_button')"
                />
            </div>
        </div>
    </modal>
</template>

<script>
    import courseRatingHelper from 'components/shared/global-courses-items/helper/course-rating-helper'
    import { mapGetters } from 'vuex'

    export default {
        name: 'modal-course-rating',
        props: {
            courseTitle: String,
            courseId: Number
        },
        mixins: [ courseRatingHelper ],
        data () {
            return {
                rating: {
                    contentQuality: 0,
                    trainerPerform: 0,
                    learningRate: 0,
                    ratingDescription: ''
                },
                isRatingSaved: false
            }
        },
        computed: {
            ...mapGetters({
                getUserRateForCourse: 'Ratings/getUserRateForCourse',
                isLoggedIn: 'isLoggedIn'
            }),
            isAllRatingDone () {
                return !Object.values(this.rating).includes(0)
            }
        },
        methods: {
            setContentRating (rating) {
                this.rating.contentQuality = rating
            },
            setTrainerRating (rating) {
                this.rating.trainerPerform = rating
            },
            setLearningRating (rating) {
                this.rating.learningRate = rating
            },
            async sendRating () {
                await this.$store.dispatch('Ratings/sendRating', {
                    courseId: this.courseId,
                    rating: this.rating
                })
                this.isRatingSaved = true
                this.$emit('ratingSaved')
                this.$store.dispatch('Ratings/setRatingSaved', true)

                this.$modal.hide('course-rating')
            },
            beforeClose () {
                this.$store.dispatch('VideoPlayer/setRatingModalVisibility', false)
                if (!this.isRatingSaved) {
                    window.sessionStorage.setItem(this.courseId, JSON.stringify(this.rating))
                }
            },
            beforeOpen () {
                this.$store.dispatch('VideoPlayer/setRatingModalVisibility', true)
            }
        },
        async created () {
            if (!this.isLoggedIn) {
                return
            }
            try {
                await this.$store.dispatch('Ratings/loadUserRatings');
            } catch (error) {
                console.error(error);
            }            
            let savedRating = this.getUserRateForCourse(this.courseId)
            let unsavedRating = JSON.parse(sessionStorage.getItem(this.courseId))

            if (savedRating) {
                const { courseId, ...rating } = savedRating
                this.rating = rating
                this.isRatingSaved = true
                this.$store.dispatch('Ratings/setRatingSaved', true)
            } else if (unsavedRating) {
                this.rating = unsavedRating
            }
        },
        beforeDestroy () {
            this.$store.dispatch('Ratings/setRatingSaved', false)
        }
    }
</script>

<style lang="scss" scoped>

.modal-course-rating {
    border: 0;
    padding: 30px 20px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 5px;
    background-color: $white;
    box-shadow: 0 20px 20px -2px  $black;
    font-family:  PlusJakartaSans-Regular, sans-serif;

    [class*="mobile"] & {
        padding: 15px;
    }

    &__course-title {
        font-family:  PPAgrandir-Medium, sans-serif;
        color: $lavender;
        font-size: 1.8rem;
        margin: 20px auto 20px;
    }

    &__question {
        font-size: 1.6rem;
        margin: 0 0 10px;
    }

    &__stars {
        padding: 15px 0 0 0;
        margin: 0 auto;
        justify-content: center;
    }

    &__feedback-info {
        font-size: 1.4rem;
        width: 100%;
        text-align: left;
    }

    &__buttons {
        display: flex;
        margin: 20px 0 0;
        align-self: flex-end;
    }

    &__textarea {
        margin: 0 0 12px;
        border: 1px solid $lavender;
        border-radius: 4px;
        background: $white;
        padding: 20px;
    }

    &__rating-item {
        border-radius: 10px;
        background: $alabaster;
        width: 100%;
        margin: 0 0 12px 0;
        padding: 10px 0;
    }
}
</style>
